/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
/* tslint:disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as import0 from '@angular/core/src/linker/ng_module_factory';
import * as import1 from '@angular/material/tooltip/tooltip';
import * as import2 from '@angular/material/core/portal/portal-directives';
import * as import3 from '@angular/material/core/overlay/overlay-directives';
import * as import4 from '@angular/material/core/compatibility/compatibility';
import * as import5 from '@angular/material/core/overlay/position/overlay-position-builder';
import * as import6 from '@angular/material/core/overlay/overlay';
import * as import8 from '@angular/material/core/overlay/overlay-container';
import * as import9 from '@angular/material/core/overlay/scroll/scroll-dispatcher';
import * as import10 from '@angular/material/core/overlay/position/viewport-ruler';
import * as import11 from '@angular/core/src/application_ref';
import * as import12 from '@angular/core/src/zone/ng_zone';
import * as import13 from '@angular/core/src/change_detection/change_detection_util';
import * as import14 from '@angular/core/src/linker/view';
import * as import15 from '@angular/core/src/linker/view_utils';
import * as import17 from '@angular/core/src/metadata/view';
import * as import18 from '@angular/core/src/linker/view_type';
import * as import19 from '@angular/core/src/change_detection/constants';
import * as import20 from '@angular/core/src/linker/component_factory';
import * as import21 from '@angular/material/core/rtl/dir';
import * as import22 from './tooltip.css.shim.ngstyle';
import * as import23 from '@angular/core/src/animation/animation_transition';
import * as import24 from '@angular/core/src/animation/animation_sequence_player';
import * as import25 from '@angular/core/src/animation/animation_styles';
import * as import26 from '@angular/core/src/animation/animation_style_util';
import * as import27 from '@angular/core/src/animation/animation_keyframe';
import * as import28 from '@angular/core/src/animation/animation_player';
import * as import29 from '@angular/core/src/security';
var MdTooltipModuleInjector = (function (_super) {
    __extends(MdTooltipModuleInjector, _super);
    function MdTooltipModuleInjector(parent) {
        return _super.call(this, parent, [TooltipComponentNgFactory], []) || this;
    }
    Object.defineProperty(MdTooltipModuleInjector.prototype, "_OverlayContainer_4", {
        get: function () {
            if ((this.__OverlayContainer_4 == null)) {
                (this.__OverlayContainer_4 = import8.OVERLAY_CONTAINER_PROVIDER_FACTORY(this.parent.get(import8.OverlayContainer, null)));
            }
            return this.__OverlayContainer_4;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdTooltipModuleInjector.prototype, "_ScrollDispatcher_5", {
        get: function () {
            if ((this.__ScrollDispatcher_5 == null)) {
                (this.__ScrollDispatcher_5 = import9.SCROLL_DISPATCHER_PROVIDER_FACTORY(this.parent.get(import9.ScrollDispatcher, null)));
            }
            return this.__ScrollDispatcher_5;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdTooltipModuleInjector.prototype, "_ViewportRuler_6", {
        get: function () {
            if ((this.__ViewportRuler_6 == null)) {
                (this.__ViewportRuler_6 = import10.VIEWPORT_RULER_PROVIDER_FACTORY(this.parent.get(import10.ViewportRuler, null), this._ScrollDispatcher_5));
            }
            return this.__ViewportRuler_6;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdTooltipModuleInjector.prototype, "_OverlayPositionBuilder_7", {
        get: function () {
            if ((this.__OverlayPositionBuilder_7 == null)) {
                (this.__OverlayPositionBuilder_7 = new import5.OverlayPositionBuilder(this._ViewportRuler_6));
            }
            return this.__OverlayPositionBuilder_7;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdTooltipModuleInjector.prototype, "_Overlay_8", {
        get: function () {
            if ((this.__Overlay_8 == null)) {
                (this.__Overlay_8 = new import6.Overlay(this._OverlayContainer_4, this, this._OverlayPositionBuilder_7, this.parent.get(import11.ApplicationRef), this, this.parent.get(import12.NgZone)));
            }
            return this.__Overlay_8;
        },
        enumerable: true,
        configurable: true
    });
    MdTooltipModuleInjector.prototype.createInternal = function () {
        this._PortalModule_0 = new import2.PortalModule();
        this._OverlayModule_1 = new import3.OverlayModule();
        this._CompatibilityModule_2 = new import4.CompatibilityModule();
        this._MdTooltipModule_3 = new import1.MdTooltipModule();
        return this._MdTooltipModule_3;
    };
    MdTooltipModuleInjector.prototype.getInternal = function (token, notFoundResult) {
        if ((token === import2.PortalModule)) {
            return this._PortalModule_0;
        }
        if ((token === import3.OverlayModule)) {
            return this._OverlayModule_1;
        }
        if ((token === import4.CompatibilityModule)) {
            return this._CompatibilityModule_2;
        }
        if ((token === import1.MdTooltipModule)) {
            return this._MdTooltipModule_3;
        }
        if ((token === import8.OverlayContainer)) {
            return this._OverlayContainer_4;
        }
        if ((token === import9.ScrollDispatcher)) {
            return this._ScrollDispatcher_5;
        }
        if ((token === import10.ViewportRuler)) {
            return this._ViewportRuler_6;
        }
        if ((token === import5.OverlayPositionBuilder)) {
            return this._OverlayPositionBuilder_7;
        }
        if ((token === import6.Overlay)) {
            return this._Overlay_8;
        }
        return notFoundResult;
    };
    MdTooltipModuleInjector.prototype.destroyInternal = function () {
    };
    return MdTooltipModuleInjector;
}(import0.NgModuleInjector));
export var MdTooltipModuleNgFactory = new import0.NgModuleFactory(MdTooltipModuleInjector, import1.MdTooltipModule);
var Wrapper_MdTooltip = (function () {
    function Wrapper_MdTooltip(p0, p1, p2, p3, p4, p5) {
        this._changed = false;
        this.context = new import1.MdTooltip(p0, p1, p2, p3, p4, p5);
        this._expr_0 = import13.UNINITIALIZED;
        this._expr_1 = import13.UNINITIALIZED;
        this._expr_2 = import13.UNINITIALIZED;
        this._expr_3 = import13.UNINITIALIZED;
        this._expr_4 = import13.UNINITIALIZED;
        this._expr_5 = import13.UNINITIALIZED;
        this._expr_6 = import13.UNINITIALIZED;
        this._expr_7 = import13.UNINITIALIZED;
        this._expr_8 = import13.UNINITIALIZED;
        this._expr_9 = import13.UNINITIALIZED;
    }
    Wrapper_MdTooltip.prototype.ngOnDetach = function (view, componentView, el) {
    };
    Wrapper_MdTooltip.prototype.ngOnDestroy = function () {
        this.context.ngOnDestroy();
    };
    Wrapper_MdTooltip.prototype.check_position = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import15.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this._changed = true;
            this.context.position = currValue;
            this._expr_0 = currValue;
        }
    };
    Wrapper_MdTooltip.prototype.check__positionDeprecated = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import15.checkBinding(throwOnChange, this._expr_1, currValue))) {
            this._changed = true;
            this.context._positionDeprecated = currValue;
            this._expr_1 = currValue;
        }
    };
    Wrapper_MdTooltip.prototype.check_showDelay = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import15.checkBinding(throwOnChange, this._expr_2, currValue))) {
            this._changed = true;
            this.context.showDelay = currValue;
            this._expr_2 = currValue;
        }
    };
    Wrapper_MdTooltip.prototype.check_hideDelay = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import15.checkBinding(throwOnChange, this._expr_3, currValue))) {
            this._changed = true;
            this.context.hideDelay = currValue;
            this._expr_3 = currValue;
        }
    };
    Wrapper_MdTooltip.prototype.check_message = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import15.checkBinding(throwOnChange, this._expr_4, currValue))) {
            this._changed = true;
            this.context.message = currValue;
            this._expr_4 = currValue;
        }
    };
    Wrapper_MdTooltip.prototype.check__deprecatedMessage = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import15.checkBinding(throwOnChange, this._expr_5, currValue))) {
            this._changed = true;
            this.context._deprecatedMessage = currValue;
            this._expr_5 = currValue;
        }
    };
    Wrapper_MdTooltip.prototype.check__matMessage = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import15.checkBinding(throwOnChange, this._expr_6, currValue))) {
            this._changed = true;
            this.context._matMessage = currValue;
            this._expr_6 = currValue;
        }
    };
    Wrapper_MdTooltip.prototype.check__matPosition = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import15.checkBinding(throwOnChange, this._expr_7, currValue))) {
            this._changed = true;
            this.context._matPosition = currValue;
            this._expr_7 = currValue;
        }
    };
    Wrapper_MdTooltip.prototype.check__matHideDelay = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import15.checkBinding(throwOnChange, this._expr_8, currValue))) {
            this._changed = true;
            this.context._matHideDelay = currValue;
            this._expr_8 = currValue;
        }
    };
    Wrapper_MdTooltip.prototype.check__matShowDelay = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import15.checkBinding(throwOnChange, this._expr_9, currValue))) {
            this._changed = true;
            this.context._matShowDelay = currValue;
            this._expr_9 = currValue;
        }
    };
    Wrapper_MdTooltip.prototype.ngDoCheck = function (view, el, throwOnChange) {
        var changed = this._changed;
        this._changed = false;
        if (!throwOnChange) {
            if ((view.numberOfChecks === 0)) {
                this.context.ngOnInit();
            }
        }
        return changed;
    };
    Wrapper_MdTooltip.prototype.checkHost = function (view, componentView, el, throwOnChange) {
    };
    Wrapper_MdTooltip.prototype.handleEvent = function (eventName, $event) {
        var result = true;
        if ((eventName == 'longpress')) {
            var pd_sub_0 = (this.context.show() !== false);
            result = (pd_sub_0 && result);
        }
        if ((eventName == 'touchend')) {
            var pd_sub_1 = (this.context.hide(1500) !== false);
            result = (pd_sub_1 && result);
        }
        if ((eventName == 'mouseenter')) {
            var pd_sub_2 = (this.context.show() !== false);
            result = (pd_sub_2 && result);
        }
        if ((eventName == 'mouseleave')) {
            var pd_sub_3 = (this.context.hide() !== false);
            result = (pd_sub_3 && result);
        }
        return result;
    };
    Wrapper_MdTooltip.prototype.subscribe = function (view, _eventHandler) {
        this._eventHandler = _eventHandler;
    };
    return Wrapper_MdTooltip;
}());
export { Wrapper_MdTooltip };
var Wrapper_TooltipComponent = (function () {
    function Wrapper_TooltipComponent(p0, p1) {
        this._changed = false;
        this.context = new import1.TooltipComponent(p0, p1);
    }
    Wrapper_TooltipComponent.prototype.ngOnDetach = function (view, componentView, el) {
    };
    Wrapper_TooltipComponent.prototype.ngOnDestroy = function () {
    };
    Wrapper_TooltipComponent.prototype.ngDoCheck = function (view, el, throwOnChange) {
        var changed = this._changed;
        this._changed = false;
        return changed;
    };
    Wrapper_TooltipComponent.prototype.checkHost = function (view, componentView, el, throwOnChange) {
    };
    Wrapper_TooltipComponent.prototype.handleEvent = function (eventName, $event) {
        var result = true;
        if ((eventName == 'body:click')) {
            var pd_sub_0 = (this.context._handleBodyInteraction() !== false);
            result = (pd_sub_0 && result);
        }
        return result;
    };
    Wrapper_TooltipComponent.prototype.subscribe = function (view, _eventHandler) {
        this._eventHandler = _eventHandler;
    };
    return Wrapper_TooltipComponent;
}());
export { Wrapper_TooltipComponent };
var renderType_TooltipComponent_Host = import15.createRenderComponentType('', 0, import17.ViewEncapsulation.None, [], {});
var View_TooltipComponent_Host0 = (function (_super) {
    __extends(View_TooltipComponent_Host0, _super);
    function View_TooltipComponent_Host0(viewUtils, parentView, parentIndex, parentElement) {
        return _super.call(this, View_TooltipComponent_Host0, renderType_TooltipComponent_Host, import18.ViewType.HOST, viewUtils, parentView, parentIndex, parentElement, import19.ChangeDetectorStatus.CheckAlways) || this;
    }
    View_TooltipComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import15.selectOrCreateRenderHostElement(this.renderer, 'md-tooltip-component', import15.EMPTY_INLINE_ARRAY, rootSelector, null);
        this.compView_0 = new View_TooltipComponent0(this.viewUtils, this, 0, this._el_0);
        this._TooltipComponent_0_3 = new Wrapper_TooltipComponent(this.injectorGet(import21.Dir, this.parentIndex, null), this.compView_0.ref);
        this.compView_0.create(this._TooltipComponent_0_3.context);
        var disposable_0 = import15.subscribeToRenderElement(this, this._el_0, new import15.InlineArray2(2, 'click', 'body'), this.eventHandler(this.handleEvent_0));
        this.init(this._el_0, (this.renderer.directRenderer ? null : [this._el_0]), [disposable_0]);
        return new import20.ComponentRef_(0, this, this._el_0, this._TooltipComponent_0_3.context);
    };
    View_TooltipComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import1.TooltipComponent) && (0 === requestNodeIndex))) {
            return this._TooltipComponent_0_3.context;
        }
        return notFoundResult;
    };
    View_TooltipComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._TooltipComponent_0_3.ngDoCheck(this, this._el_0, throwOnChange);
        this.compView_0.internalDetectChanges(throwOnChange);
    };
    View_TooltipComponent_Host0.prototype.destroyInternal = function () {
        this.compView_0.destroy();
    };
    View_TooltipComponent_Host0.prototype.visitRootNodesInternal = function (cb, ctx) {
        cb(this._el_0, ctx);
    };
    View_TooltipComponent_Host0.prototype.handleEvent_0 = function (eventName, $event) {
        this.compView_0.markPathToRootAsCheckOnce();
        var result = true;
        result = (this._TooltipComponent_0_3.handleEvent(eventName, $event) && result);
        return result;
    };
    return View_TooltipComponent_Host0;
}(import14.AppView));
export var TooltipComponentNgFactory = new import20.ComponentFactory('md-tooltip-component, mat-tooltip-component', View_TooltipComponent_Host0, import1.TooltipComponent);
var styles_TooltipComponent = [import22.styles];
var TooltipComponent_state_states = {
    'void': { 'transform': 'scale(0)' },
    'initial': { 'transform': 'scale(0)' },
    'visible': { 'transform': 'scale(1)' },
    'hidden': { 'transform': 'scale(0)' },
    '*': {}
};
function TooltipComponent_state_factory(view, element, currentState, nextState) {
    var previousPlayers = view.animationContext.getAnimationPlayers(element, ((nextState == 'void') ? null : 'state'));
    var collectedStyles = {};
    var player = null;
    var totalTime = 0;
    var defaultStateStyles = TooltipComponent_state_states['*'];
    var startStateStyles = TooltipComponent_state_states[currentState];
    if ((startStateStyles == null)) {
        (startStateStyles = defaultStateStyles);
    }
    var endStateStyles = TooltipComponent_state_states[nextState];
    if ((endStateStyles == null)) {
        (endStateStyles = defaultStateStyles);
    }
    if (((player == null) && (true && (nextState == 'visible')))) {
        player = new import24.AnimationSequencePlayer([view.renderer.animate(element, new import25.AnimationStyles(import26.collectAndResolveStyles(collectedStyles, [startStateStyles])), import26.balanceAnimationKeyframes(collectedStyles, endStateStyles, [
                new import27.AnimationKeyframe(0, new import25.AnimationStyles(import26.collectAndResolveStyles(collectedStyles, [{}]))),
                new import27.AnimationKeyframe(1, new import25.AnimationStyles(import26.collectAndResolveStyles(collectedStyles, [{}])))
            ]), 150, 0, 'cubic-bezier(0.0, 0.0, 0.2, 1)', previousPlayers)]);
        totalTime = 150;
    }
    if (((player == null) && (true && (nextState == 'hidden')))) {
        player = new import24.AnimationSequencePlayer([view.renderer.animate(element, new import25.AnimationStyles(import26.collectAndResolveStyles(collectedStyles, [startStateStyles])), import26.balanceAnimationKeyframes(collectedStyles, endStateStyles, [
                new import27.AnimationKeyframe(0, new import25.AnimationStyles(import26.collectAndResolveStyles(collectedStyles, [{}]))),
                new import27.AnimationKeyframe(1, new import25.AnimationStyles(import26.collectAndResolveStyles(collectedStyles, [{}])))
            ]), 150, 0, 'cubic-bezier(0.4, 0.0, 1, 1)', previousPlayers)]);
        totalTime = 150;
    }
    if ((player == null)) {
        (player = new import28.NoOpAnimationPlayer());
    }
    player.onDone(function () {
        player.destroy();
        import26.renderStyles(element, view.renderer, import26.prepareFinalAnimationStyles(startStateStyles, endStateStyles));
    });
    new import24.AnimationSequencePlayer(previousPlayers).destroy();
    import26.renderStyles(element, view.renderer, import26.clearStyles(startStateStyles));
    view.animationContext.queueAnimation(element, 'state', player);
    return new import23.AnimationTransition(player, currentState, nextState, totalTime);
}
var renderType_TooltipComponent = import15.createRenderComponentType('', 0, import17.ViewEncapsulation.Emulated, styles_TooltipComponent, { 'state': TooltipComponent_state_factory });
var View_TooltipComponent0 = (function (_super) {
    __extends(View_TooltipComponent0, _super);
    function View_TooltipComponent0(viewUtils, parentView, parentIndex, parentElement) {
        var _this = _super.call(this, View_TooltipComponent0, renderType_TooltipComponent, import18.ViewType.COMPONENT, viewUtils, parentView, parentIndex, parentElement, import19.ChangeDetectorStatus.CheckAlways) || this;
        _this._expr_2 = import13.UNINITIALIZED;
        _this._expr_3 = import13.UNINITIALIZED;
        _this._expr_4 = import13.UNINITIALIZED;
        return _this;
    }
    View_TooltipComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.parentElement);
        this._el_0 = import15.createRenderElement(this.renderer, parentRenderNode, 'div', new import15.InlineArray2(2, 'class', 'mat-tooltip'), null);
        this._text_1 = this.renderer.createText(this._el_0, '', null);
        this.init(null, (this.renderer.directRenderer ? null : [
            this._el_0,
            this._text_1
        ]), null);
        return null;
    };
    View_TooltipComponent0.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_3 = this.context._visibility;
        if (import15.checkBinding(throwOnChange, this._expr_3, currVal_3)) {
            var animationTransition_state = this.componentType.animations['state'](this, this._el_0, ((this._expr_3 == import13.UNINITIALIZED) ? 'void' : this._expr_3), ((currVal_3 == import13.UNINITIALIZED) ? 'void' : currVal_3));
            animationTransition_state.onDone(this.handleEvent_0.bind(this).bind(this, '@state.done'));
            this._expr_3 = currVal_3;
        }
        var currVal_2 = this.context._transformOrigin;
        if (import15.checkBinding(throwOnChange, this._expr_2, currVal_2)) {
            this.renderer.setElementStyle(this._el_0, 'transform-origin', ((this.viewUtils.sanitizer.sanitize(import29.SecurityContext.STYLE, currVal_2) == null) ? null : this.viewUtils.sanitizer.sanitize(import29.SecurityContext.STYLE, currVal_2).toString()));
            this._expr_2 = currVal_2;
        }
        var currVal_4 = import15.inlineInterpolate(1, '', this.context.message, '');
        if (import15.checkBinding(throwOnChange, this._expr_4, currVal_4)) {
            this.renderer.setText(this._text_1, currVal_4);
            this._expr_4 = currVal_4;
        }
    };
    View_TooltipComponent0.prototype.detachInternal = function () {
        var animationTransition_state = this.componentType.animations['state'](this, this._el_0, this._expr_3, 'void');
        animationTransition_state.onDone(this.handleEvent_0.bind(this).bind(this, '@state.done'));
    };
    View_TooltipComponent0.prototype.handleEvent_0 = function (eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        if ((eventName == '@state.done')) {
            var pd_sub_0 = (this.context._afterVisibilityAnimation($event) !== false);
            result = (pd_sub_0 && result);
        }
        return result;
    };
    return View_TooltipComponent0;
}(import14.AppView));
export { View_TooltipComponent0 };
//# sourceMappingURL=tooltip.ngfactory.js.map